import React from 'react';

import classes from './CheckoutSummary.module.css';

import Burger from '../../Burger/Burger';
import Button from '../../UI/Button/Button';

const CheckoutSummary = (props) => {
	return (
		<div className={classes.CheckoutSummary}>
			<h1>We hope it taste's good.</h1>
			<div style={{ width: '100%', marginTop: '2rem' }}>
				<Burger ingredients={props.checkoutItems} />
			</div>
			<div className={classes.CheckoutActions}>
				<Button buttonType="Danger" clicked={props.checkoutCancelled}>
					Cancel
				</Button>
				<Button buttonType="Success" clicked={props.checkoutContinued}>
					Checkout
				</Button>
			</div>
		</div>
	);
};

export default CheckoutSummary;
